{
  "publishConfig": {"registry": "https://nexus.pc-scol.fr/repository/npm-local-releases/"},
  "devDependencies": {
    "husky": "^9.0.11",
    "eslint-config-prettier": "^9.1.2",
    "karma-jasmine": "~5.1.0",
    "@angular/build": "^20.3.10",
    "pretty-quick": "^4.2.2",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "eslint": "^9.39.1",
    "karma-junit-reporter": "^2.0.1",
    "@angular-eslint/schematics": "20.7.0",
    "@angular/localize": "^20.3.12",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2",
    "karma-coverage": "~2.2.0",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "@angular/compiler-cli": "^20.3.0",
    "angular-eslint": "20.7.0",
    "http-serve": "^1.0.1",
    "start-server-and-test": "^2.1.3",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "karma-chrome-launcher": "~3.2.0",
    "@angular/cli": "^20.3.10",
    "eslint-plugin-prettier": "^5.5.6",
    "@typescript-eslint/eslint-plugin": "^8.62.0",
    "cypress": "^15.7.0",
    "prettier": "^3.8.4",
    "@eslint/js": "^9.39.4",
    "@angular-eslint/template-parser": "20.7.0",
    "@eslint/eslintrc": "^3.3.5",
    "@types/node": "^20.19.23",
    "@typescript-eslint/parser": "^8.62.0",
    "@angular-eslint/builder": "20.7.0",
    "typescript-eslint": "^8.62.0",
    "prettier-eslint": "^17.1.1"
  },
  "name": "@pcscol/piece-apprenant-app",
  "files": ["package.json"],
  "repository": {
    "type": "git",
    "url": "https://gitlab.pc-scol.fr/pcscol/piece/piece-apprenant-app.git"
  },
  "scripts": {
    "prepare": "husky",
    "e2e:open": "start-server-and-test start http://localhost:4214 cy:open",
    "extract:piece": "ng extract-i18n piece-apprenant-app --output-path=src/locale",
    "serve:ci": "http-serve dist/piece-apprenant-app/browser/fr -p 4214 --silent",
    "cy:install": "cypress install",
    "cy:open": "cypress open",
    "start": "ng serve --configuration=fr",
    "format": "prettier . --write",
    "e2e:piece": "npm run build:ci && start-server-and-test serve:ci http://localhost:4214 cy:run",
    "build:ci": "ng build --configuration=production --base-href / && sed -i 's|base href=\"/fr/\"|base href=\"/\"|g' dist/piece-apprenant-app/browser/fr/index.html",
    "lint": "eslint .",
    "test:piece": "ng test --watch=false --browsers=ChromiumHeadless --code-coverage",
    "cy:run": "npm run cy:install && cypress run",
    "build": "ng build",
    "watch": "ng build --watch --configuration fr",
    "ng": "ng",
    "lint:html": "eslint . --format html --output-file eslint_output.html"
  },
  "version": "34.0.1",
  "dependencies": {
    "@ngrx/store": "^20.1.0",
    "@angular/animations": "^20.3.13",
    "@angular/material": "~20.2.13",
    "@angular/compiler": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@pcscol-portail/ng-auth": "20.2.4",
    "@ngrx/store-devtools": "^20.1.0",
    "@angular/cdk": "~20.2.13",
    "@pcscol-portail/ng-authz": "20.2.4",
    "@angular/service-worker": "^20.3.0",
    "@pcscol-portail/eslint-plugin": "20.2.4",
    "@pcscol-portail/composants-pegase": "20.2.4",
    "@pcscol/idt-api-v1-angular": "1.8.0",
    "zone.js": "~0.15.0",
    "@angular/router": "^20.3.0",
    "@pcscol/piece-api-v1-angular": "34.0.0",
    "rxjs": "~7.8.0",
    "@angular/common": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@pcscol-portail/theme-pegase-apprenant": "20.2.4",
    "tslib": "^2.3.0"
  }
}